import doon from "../assets/images/projects/doon.jpg";
import bbi from "../assets/images/projects/bbi.jpg";
import phl from "../assets/images/projects/phl.jpg";
import th from "../assets/images/projects/th.webp";
import ellaglow from "../assets/images/projects/ellaglow.webp";
import homecare from "../assets/images/projects/homecare.jpg";
import BTL from "../assets/images/projects/BTL.webp";
import UNI from "../assets/images/projects/uni.webp";
import chamlyHub from "../assets/images/projects/chamly.webp";
import chamlyApp from "../assets/images/projects/chamly-app.webp";
import dosepal from "../assets/images/projects/dosepal.webp";
import stratjournal from "../assets/images/projects/stratjournal.webp";
import crm from "../assets/images/projects/CRM.webp";
import chamlyPoster from "../assets/images/projects/chamly-app-poster.jpg";
import dosepalPoster from "../assets/images/projects/dosepal-poster.jpg";
import stratjournalPhone from "../assets/images/projects/stratjournal-phone.jpg";
import chamlyClip from "../assets/videos/chamly.mp4";
import dosepalClip from "../assets/videos/dosepal.mp4";

export const projects = [
  {
    id: "chamly-hub",
    evidenceNo: "06",
    title: "Chamly Hub",
    role: "Solo · Full-stack",
    description:
      "Unified markets, budgeting, and productivity workspace in Next.js with Supabase auth and data — built around how people actually manage money day to day.",
    image: chamlyHub,
    imageKind: "screenshot",
    link: "https://hub.chamly.app/welcome",
    videos: [{ id: "6HIufNRbzRQ", title: "Chamly Hub: Markets, budgeting, and productivity" }],
    stack: ["Next.js", "Tailwind CSS", "Supabase"],
    withTeam: false,
    companyId: "chamly",
  },
  {
    id: "chamly-app",
    evidenceNo: "05",
    title: "Chamly App",
    role: "Solo · Full-stack",
    description:
      "Calm wellness app for focus and rest rituals — Next.js frontend, Supabase backend, and product UX centered on intentional daily reset moments.",
    image: chamlyApp,
    imageKind: "screenshot",
    device: "phone",
    screenImage: chamlyPoster,
    screenVideo: chamlyClip,
    link: "https://www.chamly.app",
    videos: [{ id: "_MU_wMTXgDw", title: "Chamly: Focus, Rest & Sleep rituals" }],
    stack: ["Next.js", "Tailwind CSS", "Supabase"],
    withTeam: false,
    companyId: "chamly",
  },
  {
    id: "dosepal",
    evidenceNo: "16",
    title: "dosepal",
    role: "Solo · Product",
    description:
      "Private, on-device reminder app for medications, vitamins, supplements, and pet meds — no account, no cloud. In closed testing on Google Play, with a Next.js landing site.",
    image: dosepal,
    imageKind: "screenshot",
    device: "phone",
    screenImage: dosepalPoster,
    screenVideo: dosepalClip,
    link: "https://www.dosepal.xyz",
    videos: [{ id: "oQYfs_gG2Rg", title: "dosepal: Meds, Vitamins, Supplements Reminder" }],
    stack: ["Next.js", "Tailwind CSS"],
    withTeam: false,
  },
  {
    id: "stratjournal",
    evidenceNo: "17",
    title: "StratJournal",
    role: "Solo · Full-stack",
    description:
      "Mobile-first PWA research game that helps first-year BSED Mathematics students practice reading comprehension strategies through six math-themed quests — with a facilitator view for reviewing vocabulary attempts, strategy answers, and reflections.",
    image: stratjournal,
    imageKind: "screenshot",
    device: "phone",
    screenImage: stratjournalPhone,
    link: "https://strat-journal-psi.vercel.app",
    videos: [{ id: "TzPcbBX3Src", title: "StratJournal: Comprehension Strategy" }],
    stack: ["Next.js", "TypeScript", "Tailwind CSS", "Supabase", "Serwist PWA", "Vercel"],
    withTeam: false,
  },
  {
    id: "unicef-iis",
    evidenceNo: "04",
    title: "UNICEF Immunization Information Systems",
    role: "Frontend · Vue 3",
    description:
      "Vue 3 + Firebase interfaces for DOH immunization tools (Mobile IIS / SEIR) supporting UNICEF-backed digital health pilots in the Philippines.",
    image: UNI,
    imageKind: "screenshot",
    link: "https://dev.mobileiis.ph/",
    stack: ["Vue 3", "Tailwind CSS", "Firebase"],
    withTeam: false,
    companyId: "thinkbit",
  },
  {
    id: "doon",
    evidenceNo: "07",
    title: "DOON",
    role: "Team · Next.js",
    description:
      "Philippines' first fully insured P2P car-sharing marketplace — Next.js UI on Vercel with XANO APIs for listings, booking, and host flows.",
    image: doon,
    imageKind: "screenshot",
    link: "https://www.doon.ph/",
    stack: ["Next.js", "XANO", "Tailwind CSS", "Vercel"],
    withTeam: true,
    companyId: "sandlot",
  },
  {
    id: "talent-hero",
    evidenceNo: "08",
    title: "Talent Hero",
    role: "Team · Vue 3",
    description:
      "Global talent-acquisition platform in Vue 3 + XANO — enabling companies to hire through a vetted recruiter and partner-agency network.",
    image: th,
    imageKind: "screenshot",
    link: "https://talenthero.co",
    stack: ["Vue 3", "Tailwind CSS", "XANO"],
    withTeam: true,
    companyId: "talent-hero",
    companyIds: ["talent-hero", "ahg"],
  },
  {
    id: "built-to-last",
    evidenceNo: "09",
    title: "Built to Last",
    role: "Automation · GoHighLevel",
    description:
      "GoHighLevel funnels, CRM, and nurture automation for a real-estate education brand — lead capture through follow-up without custom app overhead.",
    image: BTL,
    imageKind: "screenshot",
    link: "https://builtto-last.com/",
    stack: ["GoHighLevel"],
    withTeam: false,
    companyId: "freelance",
  },
  {
    id: "grace",
    evidenceNo: "10",
    title: "Grace Extended Care",
    role: "Automation · GoHighLevel",
    description:
      "Site and intake/CRM workflows in GoHighLevel for a licensed home-care agency serving Philadelphia and surrounding counties.",
    image: homecare,
    imageKind: "screenshot",
    link: "https://graceextendedcare.com/home",
    stack: ["GoHighLevel"],
    withTeam: false,
    companyId: "freelance",
  },
  {
    id: "ellaglow",
    evidenceNo: "11",
    title: "Ellaglow",
    role: "Automation · GoHighLevel",
    description:
      "Storefront and marketing automation in GoHighLevel for a DTC body-care brand — pages, offers, and CRM-ready customer journeys.",
    image: ellaglow,
    imageKind: "screenshot",
    link: "https://shopellaglow.com/home-page",
    stack: ["GoHighLevel"],
    withTeam: false,
    companyId: "freelance",
  },
  {
    id: "bbi",
    evidenceNo: "12",
    title: "BBI Consultancy",
    role: "Solo · Vue 3",
    description:
      "Vite + Vue 3 marketing site for a digital brand consultancy, deployed on Vercel with a clean Tailwind component system.",
    image: bbi,
    imageKind: "screenshot",
    link: "https://www.bbiconsults.com/",
    stack: ["Vite", "Vue 3", "Tailwind CSS", "Vercel"],
    withTeam: false,
    companyId: "bbi",
  },
  {
    id: "bbi-crm",
    evidenceNo: "13",
    title: "BBI CRM",
    role: "Automation · GoHighLevel",
    description:
      "CRM and pipeline automation in GoHighLevel supporting BBI consultancy operations — intake, follow-up, and client tracking.",
    image: crm,
    imageKind: "screenshot",
    link: "https://www.bbiconsults.com/",
    stack: ["GoHighLevel"],
    withTeam: false,
    companyId: "bbi",
  },
  {
    id: "construction-phl",
    evidenceNo: "14",
    title: "Construction PHL",
    role: "Solo · Vue 3",
    description:
      "Vite + Vue 3 company site for a mortgage field-services firm specializing in preservation and construction.",
    image: phl,
    imageKind: "screenshot",
    link: "https://www.constructionphl.com/",
    stack: ["Vite", "Vue 3", "Tailwind CSS", "Vercel"],
    withTeam: false,
    companyId: "freelance",
  },
  {
    id: "real-estate-ai",
    evidenceNo: "15",
    title: "AI Real Estate Growth System",
    role: "Product · Automation",
    description:
      "End-to-end AI-powered growth system for real estate teams: instant lead response, qualification, booking, and follow-up pipelines.",
    image: null,
    imageKind: "document",
    placeholderLabel: "SYSTEM BLUEPRINT",
    link: "/real-estate-ai-growth-system",
    internal: true,
    stack: ["GoHighLevel", "AI workflows", "CRM integrations"],
    withTeam: false,
    companyId: "freelance",
  },
];

export const projectGroups = [
  {
    id: "nextjs",
    label: "Next.js",
    ids: ["chamly-app", "chamly-hub", "dosepal", "stratjournal", "doon"],
  },
  {
    id: "vue",
    label: "Vue.js",
    ids: ["unicef-iis", "talent-hero", "bbi", "construction-phl"],
  },
  {
    id: "ghl",
    label: "GoHighLevel",
    ids: ["built-to-last", "grace", "ellaglow", "bbi-crm", "real-estate-ai"],
  },
];
